import ReactGA from 'react-ga';
//Configuration for google analytics tracking.  Passed into CustomizationsProvider so it can be
// merged with subdomain-specific tracking config.
var getGAConfig = function (subdomain, trackerId) {
    var isDebug = false; //getIsDebug();
    return {
        trackers: [
            {
                trackingId: trackerId,
                gaOptions: {
                    siteSpeedSampleRate: 100,
                }
            } //NOTE: a secondary, domain-specific tracker will be added by the customizations provider
        ],
        // fallbackSecondaryTracker: secondaryTrackerId ?? GA_TRACKER_SECONDARY,   //Secondary tracker, either passed in, or defaulted
        options: {
            debug: Boolean(isDebug),
            titleCase: false,
            alwaysSendToDefaultTracker: true
        },
        fields: {
            campaignName: subdomain,
            dimension1: subdomain,
            // dimension2: sidIdParam
        },
        trackerNames: ['pstracker'],
        pageViewPath: window.location.pathname + window.location.search,
    };
};
//Initialize Google Analytics.
export var initializeAnalytics = function (subdomain, gaTrackerId, gaTrackerSecondaryId) {
    if (gaTrackerSecondaryId === void 0) { gaTrackerSecondaryId = undefined; }
    var gaConfig = getGAConfig(subdomain, gaTrackerId);
    if (gaConfig) {
        var trackers = gaConfig.trackers;
        //Look for and add a secondary tracker, if possible
        // const secondaryTracker = gaTrackerSecondaryId ?? gaConfig.fallbackSecondaryTracker;
        if (gaTrackerSecondaryId) {
            var trackerName = gaConfig.trackerNames ? gaConfig.trackerNames[0] : "pstracker";
            trackers.push({ trackingId: gaTrackerSecondaryId, gaOptions: { siteSpeedSampleRate: 100, name: trackerName } });
            console.log("Secondary Tracker set to: " + gaTrackerSecondaryId);
        }
        else {
            console.log("No secondary tracker. Not provided, and no fallbackSecondaryTracker prop in analyticsConfig.");
        }
        ReactGA.initialize(trackers, gaConfig.options);
        ReactGA.set(gaConfig.fields, gaConfig.trackerNames); //Add dimensions        
        ReactGA.pageview(gaConfig.pageViewPath, gaConfig.trackerNames); //app page view
    }
};
